export enum PICKER_BUTTON_TEST_IDS {
    EPG_DATE_PICKER = 'epg_date_picker',
}
